var _path, _mask, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsoPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M1.21718 7.46277L0.149968 20.4871C0.101368 21.0804 0.379564 21.6532 0.875975 21.9819L12.969 29.9881C13.3684 30.1791 13.838 30.197 14.2567 30.0234L14.4578 29.9227C14.4591 29.9219 14.4605 29.9211 14.4618 29.9203L14.462 29.9206L26.8021 23.7388C27.233 23.4929 27.5372 23.0502 27.592 22.5331L27.6331 9.13973C27.6344 8.70769 27.4645 8.29274 27.1605 7.98575L21.8569 2.63025C21.711 2.44747 21.5118 2.31452 21.2871 2.24974L21.1446 2.20868L15.3838 0.649255C15.02 0.550773 14.6333 0.581184 14.2893 0.735328L2.02799 6.23045C1.58239 6.47641 1.26812 6.93116 1.21718 7.46277Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 19,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54027 10.1681L4.83821 18.7362C4.80624 19.1265 4.98925 19.5033 5.31581 19.7195L13.2712 24.9864C13.5339 25.112 13.8428 25.1238 14.1183 25.0097L14.2506 24.9434C14.2515 24.9429 14.2524 24.9423 14.2532 24.9418L14.2534 24.942L22.3713 20.8753C22.6548 20.7136 22.8549 20.4223 22.8909 20.0821L22.918 11.2713C22.9188 10.9871 22.807 10.7141 22.6071 10.5122L19.1181 6.98907C19.0221 6.86883 18.8911 6.78137 18.7432 6.73875L18.6495 6.71174L14.8597 5.68588C14.6204 5.62109 14.366 5.6411 14.1398 5.7425L6.07366 9.35746C5.78052 9.51927 5.57378 9.81842 5.54027 10.1681Z",
    fill: "url(#paint1_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5887 9.57534L5.58899 9.57608L5.29719 13.1344L4.7865 19.3695L13.6562 25.2417L13.6563 25.2416L22.8888 20.6166L22.8894 20.6169L22.9195 10.828L18.9706 6.80473L14.4898 5.58617L5.5887 9.57534Z",
    fill: "url(#paint2_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49741 11.5996L5.58853 9.57496L14.4896 5.5858L18.9705 6.80436L8.49741 11.5996Z",
    fill: "url(#paint3_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9192 10.8277L18.9704 6.8044L18.7093 18.144L22.8891 20.6166L22.9192 10.8277Z",
    fill: "url(#paint4_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7091 18.1437L18.9701 6.80442L8.49714 11.5993L18.7091 18.1437Z",
    fill: "url(#paint5_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58854 9.5757L8.49647 11.5995L4.78532 19.3705L5.58854 9.5757Z",
    fill: "url(#paint6_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78629 19.3693L8.49769 11.5997L18.7094 18.1436L13.656 25.2415L4.78629 19.3693Z",
    fill: "url(#paint7_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8886 20.6163L13.656 25.2414L18.7091 18.1438L22.8886 20.6163Z",
    fill: "url(#paint8_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M8.49741 11.5996L5.58853 9.57496L14.4896 5.5858L18.9705 6.80436L8.49741 11.5996Z",
    fill: "url(#paint9_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M22.9192 10.8277L18.9704 6.8044L18.7093 18.144L22.8891 20.6166L22.9192 10.8277Z",
    fill: "url(#paint10_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M18.7091 18.1437L18.9701 6.80442L8.49714 11.5993L18.7091 18.1437Z",
    fill: "url(#paint11_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M5.58854 9.5757L8.49647 11.5995L4.78532 19.3705L5.58854 9.5757Z",
    fill: "url(#paint12_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.36
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78629 19.3693L8.49769 11.5997L18.7094 18.1436L13.656 25.2415L4.78629 19.3693Z",
    fill: "url(#paint13_linear)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.8886 20.6163L13.656 25.2414L18.7091 18.1438L22.8886 20.6163Z",
    fill: "url(#paint14_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.26
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8886 20.6163L13.656 25.2414L18.7091 18.1438L22.8886 20.6163Z",
    fill: "black"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M5.51854 10.1794L4.81648 18.7474C4.78451 19.1377 4.96752 19.5145 5.29408 19.7307L13.2495 24.9976C13.5122 25.1233 13.8211 25.1351 14.0966 25.0209L14.2289 24.9546C14.2297 24.9541 14.2306 24.9536 14.2315 24.9531L14.2317 24.9532L22.3495 20.8865C22.6331 20.7248 22.8331 20.4336 22.8692 20.0934L22.8962 11.2826C22.8971 10.9983 22.7853 10.7254 22.5853 10.5234L19.0964 7.0003C19.0004 6.88006 18.8694 6.7926 18.7215 6.74998L18.6278 6.72297L14.838 5.69711C14.5987 5.63232 14.3443 5.65233 14.118 5.75373L6.05193 9.36869C5.7588 9.5305 5.55205 9.82965 5.51854 10.1794Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.0925,
    y1: -14.1828,
    x2: -15.3506,
    y2: 12.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.0103,
    y1: -4.07138,
    x2: -5.35885,
    y2: 13.6792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.44464,
    y1: -1.22655,
    x2: -1.75746,
    y2: 23.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.1702,
    y1: 5.13068,
    x2: 12.0526,
    y2: 11.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 15.2674,
    y1: 0.602841,
    x2: 7.10458,
    y2: 9.22798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 11.778,
    y1: 4.09349,
    x2: 6.37347,
    y2: 18.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 2.84736,
    y1: 5.94815,
    x2: -2.63406,
    y2: 14.5212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 6.1829,
    y1: 4.67191,
    x2: -2.37006,
    y2: 22.2194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 15.8769,
    y1: 16.7603,
    x2: 15.4513,
    y2: 25.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4967FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C844DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 6.53426,
    y1: 5.07806,
    x2: 28.7199,
    y2: 11.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 17.8873,
    y1: 7.242,
    x2: 23.2349,
    y2: 20.4768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 13.6358,
    y1: 8.95977,
    x2: 23.0442,
    y2: 23.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -0.0235194,
    y1: 10.0286,
    x2: 12.7061,
    y2: 17.1566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625634,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 8.8058,
    y1: 11.4752,
    x2: 9.63994,
    y2: 18.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 16.6716,
    y1: 18.9671,
    x2: 18.4277,
    y2: 23.3134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoPlanIcon);
export default __webpack_public_path__ + "static/media/IsoPlanIcon.c749af1e804eacfe80824066c92fc010.svg";
export { ForwardRef as ReactComponent };